// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
const clientScss = require('./client/client.scss'); //client styles

const { loopTiles } = require('./scriptPartials/tiles');
const { addHyperLinkToFormCtas } = require('./scriptPartials/form-cta-hyperlink');
const { handleFooter } = require('./scriptPartials/corpHeaderFooter/handleFooter');
const { stickyHeader } = require('./scriptPartials/corpHeaderFooter/stickyHeader');
const { initSectionHeaderTiles } = require('./scriptPartials/handleSectionHeaderTiles');
const flipbook = require('./scriptPartials/flipbook');

const { handleFilterInit } = require('./scriptPartials/filter/handleFiltering'); // OB-6702 filter functionality
const { filterTileAnim } = require('./scriptPartials/filter/tileAnimation.js'); // Uberflip GWL OB-6702
const { alignItemLevel, CTAshift } = require('./scriptPartials/alignItemLevel.js');
const { languageSelector } = require('./scriptPartials/selectorPosition.js');
const { languageLabelUpdates } = require('./scriptPartials/languageLabel.js');

const { scrollcta } = require('./scriptPartials/alignItemLevel.js');
const {
  handlehubnav,
  localselector,
  hubnavClose,
  hideNav,
} = require('./scriptPartials/handlehubnav.js');
const { handlePortugueseHeader, mobileViewPTheader } = require('./scriptPartials/handlePt.js');
const { hideHeaderMenu } = require('./scriptPartials/hideHeaderMenu.js');
const { changeText } = require('./scriptPartials/linkUpdate.js');
const { changeDateTime } = require('./scriptPartials/itemLevel.js');
const { handleFilterChange } = require('./scriptPartials/handleFilterDropdown.js');
const { handleDescriptionPositioning } = require('./scriptPartials/handleDescriptionPositioning.js');

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    window.onbrandCustomLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    // -- Hub Events -- //
    Hubs.Events.on('load', () => {
      if (!window.onbrandCustomLoaded) {
        // Add your onloads here...
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
        handlePortugueseHeader();
        handleFooter();
        loopTiles();
        flipbook();
        initSectionHeaderTiles();
        handleFilterInit(); // OB-6702 filter functionality
        setInterval(() => {
          filterTileAnim(); // Uberflip GWL OB-6702
        }, 500);
        alignItemLevel();
        CTAshift();
        languageSelector();
        languageLabelUpdates();
        // end your onloads before here...
        scrollcta();
        handlehubnav();
        hubnavClose();
        hideNav();
        localselector(); //OB-7749 to remove double click
        mobileViewPTheader();
        hideHeaderMenu(translations);
        changeText();
        changeDateTime();
        handleFilterChange(); //Uberflip Outsource OB-10258
        handleDescriptionPositioning(); // Uberflip Outsource OB-10330
        // end your onloads before here...
        window.onbrandCustomLoaded = true;
      }
    })
      .on('itemsLoaded', (itemIds, selectors) => {
        loopTiles();
        initSectionHeaderTiles();
        filterTileAnim(); // Uberflip GWL OB-6702
      }) //eslint-disable-line no-unused-vars
      .on('resize', () => {
        scrollcta();
        // adjust side cta or addThis by passing a number into the function
        // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();

        handlePortugueseHeader();
        handleFooter();
      })
      .on('scroll', () => {
        scrollcta();
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();

        stickyHeader();

        handlehubnav();
      })
      .on('ctaActivate', (ctaId) => {
        addHyperLinkToFormCtas(ctaId, window.obData.formCtaPrivacyPolicy);
      }) //eslint-disable-line no-unused-vars
      .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {}); //eslint-disable-line no-unused-vars

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  },
};



// WEBPACK FOOTER //
// ./onbrand.js